import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as Excel from '@grapecity/spread-excelio';
import * as GC from '@grapecity/spread-sheets';
import { IAppConfig } from '@models/appconfig';
import { InterceptorSkipHeader } from '@models/headers/interceptor-skip-header';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppConfigProvider {
  public environment: ReplaySubject<IAppConfig> = new ReplaySubject(1);

  constructor(private readonly http: HttpBackend) {}

  load() {
    const headers = new HttpHeaders().set(InterceptorSkipHeader, '');
    const httpClient = new HttpClient(this.http);

    return httpClient
      .get('../config.json', { headers })
      .pipe(
        tap((configFile: IAppConfig) => {
          this.environment.next(configFile);
          GC.Spread.Sheets.LicenseKey = configFile.SPREAD.LICENSE;
          (Excel as any).LicenseKey = configFile.SPREAD.LICENSE;
        })
      )
      .toPromise();
  }
}
